import React, { useState, useEffect } from "react";
import db from "../../../db/index.json";
import ParagraphTag from "../../reusebale/Paragraph";
import ImageTag from "../../reusebale/imageTag";
import ReactPaginate from "react-paginate";
import NoData from "../../reusebale/noData";
import LeaseTableLoader from "../../skeleton-loader/lease-table"
import {
  ArrowUpDown,
  ArrowDownUp,
  SquareCheck,
  SquareX,
  SquarePen,
  ShieldOff,
  ShieldX,
  FileCheck2,
  Hourglass
} from "lucide-react";
import BaseUrl from "../../../constants/BaseUrl";
import { useSelector } from "react-redux";
import moment from "moment";


const LeasesTable = ({ isViewDetails, onViewCreate, search, leasesData, loading, currentPage, totalPages, totalLeases, onPageChange }) => {
  const { lease } = db;
  const { loginSuccess } = useSelector((state) => state.auth);

  const [AllLeases, setAllLeases] = useState([]);
  const [filteredLeases, setFilteredLeases] = useState([]);

  const itemsPerPage = 10;

  function CalculateDaysBetween(date1, date2) {
    const startDate = moment(date1);
    const endDate = moment(date2);
    return endDate.diff(startDate, "days");
  }

  // Update AllLeases when leasesData prop changes
  useEffect(() => {
    if (leasesData) {
      const data = leasesData.map((item) => ({
        ...item,
        duration: CalculateDaysBetween(item.startDate, item.endDate),
        rent: CalculateTotalRent(item)
      }));
      setAllLeases(data);
    }
  }, [leasesData]);

  useEffect(() => {
    if (!search) {
      setFilteredLeases(AllLeases);
    } else {
      const filtered = AllLeases.filter((item) => {
        const tenantName = `${item?.tenantInfo?.firstName} ${item?.tenantInfo?.lastName}`;
        return (
          item?.propertyInfo?.propertyName?.toUpperCase().includes(search.toUpperCase()) ||
          item?.unitInfo?.unitName?.toUpperCase().includes(search.toUpperCase()) ||
          tenantName?.toUpperCase().includes(search.toUpperCase())
        );
      });
      setFilteredLeases(filtered);
    }
  }, [search, AllLeases]);

  // Use filteredLeases directly (no client-side pagination since we have server-side)
  const paginatedData = filteredLeases;

  const handlePageClick = ({ selected }) => {
    onPageChange(selected + 1); // ReactPaginate uses 0-based index, API uses 1-based
  };

  const onViewDetails = (status, id) => {
    isViewDetails(status, id);
  };

  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...filteredLeases].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setFilteredLeases(sorted);
  };


  function CalculateTotalRent(item) {
    if (!item) {
      return "$ 0";
    }

    // Get base rent from unitInfo
    const baseRent = Number(item.unitInfo?.rent) || 0;

    // Calculate additional charges
    const additionalChargesTotal = Array.isArray(item.additionalCharges)
      ? item.additionalCharges.reduce((sum, charge) => {
          return sum + (Number(charge.amount) || 0);
        }, 0)
      : 0;

    // Total rent = base rent + additional charges
    const total = baseRent + additionalChargesTotal;

    return `$ ${total}`;
  }

  return (
    <div className="h-full">
      <div className="bg-white w-full h-[98%]">
        <div className="w-[95%] mx-auto h-full">
          <div className="flex justify-between items-center h-[12%]">
            <div className="w-[70%]">
              <ParagraphTag
                content={lease.heading}
                classes="text-darkColor font-popinsSemiBold text-lg"
              />
            </div>
          </div>
          <div className="overflow-x-auto w-full h-[88%] panelScroll mt-1">
            <table className="w-full ">
              <thead className="sticky top-0 bg-white">
                <tr className="border-b border-black/20">
                  <th className="w-[20%] text-left pb-2">
                    <span className="flex">
                      <ParagraphTag
                        content={lease.heading}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />

                    </span>
                  </th>
                  <th className="w-[8%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={lease.units}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />

                    </span>
                  </th>
                  <th className="w-[8%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={lease.status}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "status" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("status")}
                        />
                      )}
                    </span>
                  </th>


                  <th className="w-[20%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={lease.duration}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                      {sortConfig.key === "duration" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("duration")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("duration")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("duration")}
                        />
                      )}
                    </span>
                  </th>

                  <th className="w-[8%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={lease.rent}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "rent" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("rent")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("rent")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("rent")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[8%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={lease.deposit}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "deposit" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("securityDepositAmount")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("securityDepositAmount")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("securityDepositAmount")}
                        />
                      )}
                    </span>
                  </th>

                  <th className="w-[28%] text pr-4 pb-2">
                    <ParagraphTag
                      content={lease.actions}
                      classes="text-darkColor/40 font-popinsSemiBold text-xs"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((item) => {

                  const TenantName = `${item?.tenantInfo.firstName} ${item?.tenantInfo.lastName}`
                  if (item?.propertyInfo?.propertyName?.toUpperCase()?.includes(search.toUpperCase())
                    ||
                    item.unitInfo.unitName?.toUpperCase()?.includes(search.toUpperCase())
                    ||
                    TenantName?.trim()?.toUpperCase()?.includes(search.toUpperCase())

                  ) {
                    return (
                      <tr
                        key={item.id}
                        className="hover:bg-gray-100 rounded-md cursor-pointer"
                      >

                        <td className="py-2">
                          <div className="flex items-center justify-between">
                            <div className="w-[18%] rounded-full">
                              <ImageTag
                                path="/assets/daashboard/balance.png"
                                classes="w-full"
                                altText="logo"
                              />
                            </div>

                            <div
                              className="w-[78%] cursor-pointer"
                              onClick={() => {
                                onViewDetails(item.status, item._id);
                              }}
                            >
                              <ParagraphTag
                                content={item.ID}
                                classes="text-darkColor/50 font-popinsMedium text-xs"
                              />
                              <ParagraphTag
                                content={item?.propertyInfo?.propertyName}
                                classes="text-darkColor font-popinsSemiBold text-sm"
                              />
                            </div>
                          </div>
                        </td>
                        <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                          {item?.unitInfo?.unitName}
                        </td>
                        <td className="py-2 font-popinsMedium text-darkColor text-sm">
                          <span className="flex justify-center">
                            {(() => {
                              switch (item.status) {
                                case "active":
                                  return (
                                    <SquareCheck color="#01CB78" size={20} />
                                  );
                                case "draft":
                                  return (
                                    <SquarePen color="#e38979" size={20} />
                                  );
                                case "rejected":
                                  return <SquareX color="#E43B3B" size={20} />;
                                case "inActive":
                                  return (
                                    <ShieldOff color="#BFCDDB" size={20} />
                                  );
                                case "completed":
                                  return (
                                    <FileCheck2 color="#01CB78" size={20} />
                                  );
                                case "pendingPayment":
                                  return (
                                    <Hourglass color="#F59E0B" size={20} />
                                  );
                                default:
                                  return <ShieldX color="#FF0000" size={20} />;
                              }
                            })()}
                          </span>
                        </td>

                        <td className="py-2 px-4 font-popinsMedium text-darkColor text-xs text-center">
                          <div className="flex flex-col">
                            <span>{`${moment(item?.startDate).format(
                              "MM/DD/YYYY"
                            )} - ${moment(item?.endDate).format(
                              "MM/DD/YYYY"
                            )}`}</span>
                            <span className="text-darkColor/50">{`${CalculateDaysBetween(
                              item?.startDate,
                              item?.endDate
                            )} Days left`}</span>
                          </div>
                        </td>
                        <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">

                          {item?.rent}

                        </td>
                        <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                          {`$ ${item?.securityDepositAmount
                            ? item?.securityDepositAmount
                            : 0
                            }`}
                        </td>
                        <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm">
                          <div className="flex justify-end">
                            <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                              {`${item?.tenantInfo.firstName} ${item?.tenantInfo.lastName}`}
                            </td>
                            <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                              {`${item?.tenantInfo.cellNo} `}
                            </td>
                          </div>
                        </td>
                      </tr>
                    )

                  }

                })}
              </tbody>
            </table>
            {loading &&
              <LeaseTableLoader />
            }
            {AllLeases.length === 0 && (
              <div className="w-full flex justify-center mt-5">
                <NoData />
              </div>
            )}
          </div>
        </div>
      </div>
      {totalPages > 1 && (
        <div className="flex justify-center h-[13%] items-center">
          <ReactPaginate
            previousLabel="Previous"
            nextLabel="Next"
            breakLabel="..."
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            forcePage={currentPage - 1}
            containerClassName="flex space-x-2 items-center"
            pageClassName="px-3 py-1 border rounded-md text-sm font-popinsMedium cursor-pointer"
            previousClassName="px-3 py-1 border rounded-l-md text-sm cursor-pointer font-popinsMedium"
            nextClassName="px-3 py-1 border rounded-r-md text-sm font-popinsMedium cursor-pointer font-popinsMedium"
            disabledClassName="opacity-50 !cursor-not-allowed"
            activeClassName="bg-themeColor text-white"
            breakClassName="px-3 py-1 text-sm font-popinsMedium"
          />
        </div>
      )}
    </div>
  );
};

export default LeasesTable;
